import { useState } from 'react';
import {Box, Button, Typography} from '@mui/material'
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary, {
  accordionSummaryClasses,
} from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
  ))(({ theme }) => ({
    borderRadius: "24px",
    border: `2px solid ${theme.palette.divider}`,
    // border: `2px solid #B557AF`,
    background: 'linear-gradient(rgb(133, 76, 173) 78.77%, #5D2A79 115.46%)',
    overflow: "hidden",
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&::before': {
      display: 'none',
    },
}));
  
const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
      expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
      {...props}
    />
  ))(({ theme }) => ({
    flexDirection: 'row-reverse',
    borderRadius: "24px",
    // borderBottom: `2px solid #B557AF`,
    [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]:
      {
        transform: 'rotate(90deg)',
      },
    [`& .${accordionSummaryClasses.content}`]: {
      marginLeft: theme.spacing(1),
    },
    ...theme.applyStyles('dark', {
      backgroundColor: 'rgba(255, 255, 255, .05)',
    }),
}));
  
const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(4),
    borderRadius: "0 0 24px 24px",
    maxHeight: "55vh",  // Limits the height of details
    overflowY: "auto",   // Enables scrolling when content overflows
}));

const CustomTypography = styled(Typography)(({theme}) => ({
    color: '#E1E1E6',

}))

export default function InterviewAttemptsInfo({attempt}) {
    const [expanded, setExpanded] = useState('panel1');

    const handleChange = (panel) => (event, newExpanded) => {
      setExpanded(newExpanded ? panel : false);
    };

    return (
        <Box sx={{
            width: '100%',
            height: '100%',
        }}>
            <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" data-cy='interview-question1-accordion'>
                <CustomTypography component="span"><strong>Question 1: </strong> {attempt.question[0]}</CustomTypography>
                </AccordionSummary>
                <AccordionDetails>
                    <CustomTypography variant='h5'>
                        Domain Knowledge
                    </CustomTypography>
                    <CustomTypography>
                        <strong>Score: </strong> {attempt.domainScore[0]}%
                    </CustomTypography>
                    <CustomTypography>
                        <strong>Feedback: </strong> {attempt.domainFeedback[0]}
                    </CustomTypography>
                    <br />
                    <CustomTypography variant='h5'>
                        Confidence
                    </CustomTypography>
                    <CustomTypography>
                        <strong>Score: </strong> {attempt.confidenceScore[0]}%
                    </CustomTypography>
                    <CustomTypography>
                        <strong>Feedback: </strong> {attempt.confidenceFeedback[0]}
                    </CustomTypography>
                    <br />
                    <CustomTypography variant='h5'>
                        Stress Prediction
                    </CustomTypography>
                    <CustomTypography>
                        <strong>Feedback: </strong> {attempt.stressPredictLabel[0] === '1' ? "A little stressed and nervous, would be good to relax a little" : "No Stress Detected"}
                    </CustomTypography>
                    <br />
                    <CustomTypography variant='h5'>
                        Proctoring
                    </CustomTypography>
                    <CustomTypography>
                        <strong>Referring to Device/Paper Sources: </strong> {attempt.class1Score[0]}%
                    </CustomTypography>
                    <CustomTypography>
                        <strong>Talking on the Phone: </strong> {attempt.class2Score[0]}%
                    </CustomTypography>
                    <CustomTypography>
                        <strong>Feedback: </strong> {attempt.cheatingFeedback[0]}
                    </CustomTypography>
                </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                <AccordionSummary aria-controls="panel2d-content" id="panel2d-header" data-cy='interview-question2-accordion'>
                <CustomTypography component="span"><strong>Question 2: </strong> {attempt.question[1]}</CustomTypography>
                </AccordionSummary>
                <AccordionDetails>
                <CustomTypography variant='h5'>
                        Domain Knowledge
                    </CustomTypography>
                    <CustomTypography>
                        <strong>Score: </strong> {attempt.domainScore[1]}%
                    </CustomTypography>
                    <CustomTypography>
                        <strong>Feedback: </strong> {attempt.domainFeedback[1]}
                    </CustomTypography>
                    <br />
                    <CustomTypography variant='h5'>
                        Confidence
                    </CustomTypography>
                    <CustomTypography>
                        <strong>Score: </strong> {attempt.confidenceScore[1]}%
                    </CustomTypography>
                    <CustomTypography>
                        <strong>Feedback: </strong> {attempt.confidenceFeedback[1]}
                    </CustomTypography>
                    <br />
                    <CustomTypography variant='h5'>
                        Stress Prediction
                    </CustomTypography>
                    <CustomTypography>
                        <strong>Feedback: </strong> {attempt.stressPredictLabel[1] === '1' ? "A little stressed and nervous, would be good to relax a little" : "No Stress Detected"}
                    </CustomTypography>
                    <br />
                    <CustomTypography variant='h5'>
                        Proctoring
                    </CustomTypography>
                    <CustomTypography>
                        <strong>Referring to Device/Paper Sources: </strong> {attempt.class1Score[1]}%
                    </CustomTypography>
                    <CustomTypography>
                        <strong>Talking on the Phone: </strong> {attempt.class2Score[1]}%
                    </CustomTypography>
                    <CustomTypography>
                        <strong>Feedback: </strong> {attempt.cheatingFeedback[1]}
                    </CustomTypography>
                </AccordionDetails>
            </Accordion>
        </Box>
    )
}